// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ShopArticlesListPagingResultModel from '../../model/shop-articles-list-paging-result-model';
import ShopArticlesListPagingResultDTO from '../dto/shop-articles-list-paging-result-dto';
import dtoSchema from '../schemas/shop-articles-list-paging-result-schema';
import ShopArticlesListModel from '../../model/shop-articles-list-model';
import ResourceLinkModel from '../../model/resource-link-model';
import PaginationDataModel from '../../model/pagination-data-model';

export default abstract class ShopArticlesListPagingResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ShopArticlesListPagingResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => ShopArticlesListModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.paginationData = data.paginationData ? PaginationDataModel.toModel(data.paginationData) : undefined;
    }
  }
  /**
  */
  items?: ShopArticlesListModel[];
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  paginationData?: PaginationDataModel;

  static toModel(dto: DeepPartial<ShopArticlesListPagingResultDTO>): ShopArticlesListPagingResultModel;
  static toModel(dto: DeepPartial<ShopArticlesListPagingResultDTO> | undefined | null): ShopArticlesListPagingResultModel | undefined;
  static toModel(dto: DeepPartial<ShopArticlesListPagingResultDTO> | undefined | null): ShopArticlesListPagingResultModel | undefined {
    return dto ? new ShopArticlesListPagingResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ShopArticlesListPagingResultModel> | ShopArticlesListPagingResultModel): ShopArticlesListPagingResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
      paginationData: unwrapped.paginationData,
    } as ShopArticlesListPagingResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ShopArticlesListPagingResultModel, can not map to ShopArticlesListPagingResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
